import {
  SharedFileRequest,
  SharedFileRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { MAX_SHARED_FILE_UPLOAD_ATTEMPTS } from "../modules/SharedFile/configs/utils";

import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";
import { selectorSharedFileReUploadAttempts } from "./selectorSharedFileReUploadAttempts";

export function selectorIsSharedFileReUploadAvailable(
  sharedFile: SharedFileRequest | undefined
): boolean {
  return (
    selectorIsSharedFileNotNoneContext(sharedFile?.contextType) &&
    sharedFile?.status === SharedFileRequestStatus.PENDING_SUBMISSION &&
    selectorSharedFileReUploadAttempts(sharedFile) <
      MAX_SHARED_FILE_UPLOAD_ATTEMPTS
  );
}
